module.exports = {"id":"181795","name":"Fedor Kudryashov","rating":"73","photo":"./data/images/photos/0/181795.png","club":{"name":"Rubin Kazan","logo":"./data/images/clubs/RubinKazan.png"},"positions":["DC","DLG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FedorKudryashov0.json
// module id = 1393
// module chunks = 0